import * as uuid from 'uuid';

const objectMap = new WeakMap();

// A utility function that associates an object instance with a UUID (using WeakMap)
export function getObjectId(obj: object) {
  if (!obj) return 'null-oid';

  if (!objectMap.has(obj)) {
    objectMap.set(obj, uuid.v4());
  }

  return objectMap.get(obj);
}

export default getObjectId;
